import {
    FETCH_USERS_START,
    FETCH_USERS_SUCCESS,
    FETCH_USERS_ERROR,
    ADD_USER_SUCCESS,
    ADD_USER_ERROR,
    // UPDATE_USER_SITES_SUCCESS,
    UPDATE_USER_ACCOUNT_SUCCESS,
    RESET_USER_PASSWORD_SUCCESS,

    FETCH_ALL_TECHNICIANS_SUCCESS,
    FETCH_ALL_TECHNICIANS_ERROR,
    FETCH_ALL_DOCTORS_SUCCESS,
    FETCH_ALL_DOCTORS_ERROR,


    FETCH_RIS_USERS_WITH_MIPS_SUCCESS,
    FETCH_RIS_USERS_WITH_MIPS_ERROR,
    CREATE_RIS_USER_SUCCESS,
    CREATE_RIS_USER_START,
    ADD_UPDATE_RIS_USER_MIPS_START,
    ADD_UPDATE_RIS_USER_MIPS_SUCCESS,
    CREATE_RIS_USER_ERROR,
    ADD_UPDATE_RIS_USER_MIPS_ERROR,
    SET_USERS_PAGINATION,
    UPDATE_RIS_USER_START,
    UPDATE_RIS_USER_SUCCESS,
    UPDATE_RIS_USER_ERROR,
    DELETE_RIS_USER_SUCCESS,
    DELETE_RIS_USER_ERROR,
    UNASSIGN_USER_MIP_SUCCESS,
    FETCH_USER_SKILLS_SUCCESS,
    ADD_USER_SKILL_SUCCESS,
    DELETE_USER_SKILL_SUCCESS,
    FETCH_USER_MIPS_SUCCESS,
    FETCH_USER_MIPS_ERROR,
    ASSIGN_USER_MIP_SUCCESS,
    RESET_USER_MIPS,
    UPDATE_USER_MIPS_SUCCESS,
    SET_SELECTED_USER
} from '../../actions/admin/usersActions';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_USER = {
  userId: 0,
  firstName: "",
  lastName: "",
  gender: "",
  email: "",
  enabled: true,
  accountNonLocked: true,
  changePasswordAtLogon: true,
  groupIdForAdmin: null,
  twoFactorAuthType: "EMAIL",
  roles: [],
  risUsers: [],
  userSkills: [],
};

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    users: [],
    technicians: [],
    doctors: [],
    risUsers: [],
    userMips: [],
    selectedUser: INIT_USER,
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
};

const usersReducer = (state = INIT_STATE, action) => {
    let newState;
    let newUsers;
    let index;
    switch (action.type) {
        case FETCH_USERS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_USERS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, users: action.users };
        }
        case FETCH_USERS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_USERS_PAGINATION: {
            return { ...state, error: '', message: '', pagination: { ...action.pagination } };
        }
        case SET_SELECTED_USER: {
            const newState = { ...state }
            newState.selectedUser = action.payload;
            return newState;
        }
        case ADD_USER_SUCCESS: {
            newState = { ...state }
            newUsers = [action.user, ...newState.users];
            newState.users = [...newUsers];
            newState.selectedUser = action.user;
            return newState;
        }
        case ADD_USER_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case UPDATE_USER_ACCOUNT_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.userAccount.userId);
            if (index > -1) {
                newUsers.splice(index, 1, { ...newUsers[index], ...action.userAccount });
                newState.selectedUser = newUsers[index];
            }
            newState.users = [...newUsers];
            return newState;
        }
        // case UPDATE_USER_SITES_SUCCESS: {
        //     newState = { ...state }
        //     newUsers = [...newState.users];
        //     index = newUsers.findIndex(user => user.userId === action.user.userId);
        //     if (index > -1) {
        //         newUsers.splice(index, 1, action.user);
        //     }
        //     newState.users = [...newUsers];
        //     return newState;
        // }
        case RESET_USER_PASSWORD_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.email === action.accountInfo.email);
            if (index > -1) {
                newUsers.splice(index, 1, { ...newUsers[index], ...action.accountInfo });
                newState.selectedUser = newUsers[index];
            }
            newState.users = [...newUsers];
            return newState;
        }
        case FETCH_ALL_TECHNICIANS_SUCCESS: {
            newState = { ...state }
            newState.technicians = action.technicians.length > 0 ? [...action.technicians] : [];
            return newState;
        }
        case FETCH_ALL_TECHNICIANS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        case FETCH_ALL_DOCTORS_SUCCESS: {
            newState = { ...state }
            newState.doctors = action.doctors.length > 0 ? [...action.doctors] : [];
            return newState;
        }
        case FETCH_ALL_DOCTORS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        case FETCH_RIS_USERS_WITH_MIPS_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.payload.userId);
            if (index > -1) {
                newUsers.splice(index, 1, { ...newUsers[index], risUsers: action.payload.risUsers });
                newState.selectedUser = newUsers[index];
            }
            newState.users = [...newUsers];
            return newState;
        }

        case FETCH_RIS_USERS_WITH_MIPS_ERROR: {
            return { ...state, loading: false, error: action.error };
        }
        case CREATE_RIS_USER_START:
        case ADD_UPDATE_RIS_USER_MIPS_START: {
            return { ...state, submitting: true }
        }
        case CREATE_RIS_USER_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.risUserMips.userId);
            if (index > -1) {
                let user = { ...newUsers[index] };
                let risUsers = user.risUsers && user.risUsers.length > 0 ? [...user.risUsers] : [];
                risUsers.push({ ...action.risUserMips });
                user = { ...user, risUsers };
                newUsers.splice(index, 1, user);
                newState.selectedUser = user;
            }
            return { ...state, submitting: false, users: [...newUsers], selectedUser: newState.selectedUser || state.selectedUser }
        }
        case ADD_UPDATE_RIS_USER_MIPS_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.risUserMips.userId);
            if (index > -1) {
                let user = { ...newUsers[index] };
                let risUsers = user.risUsers && user.risUsers.length > 0 ? [...user.risUsers] : [];
                let risUserIndex = risUsers.findIndex(risUser => risUser.risId === action.risUserMips.risId);
                if (risUserIndex > -1) {
                    risUsers.splice(risUserIndex, 1, { ...risUsers[risUserIndex], ...action.risUserMips });
                }
                user.risUsers = [...risUsers];
                newUsers.splice(index, 1, { ...user });
                newState.selectedUser = { ...user };
            }
            return { ...state, submitting: false, users: [...newUsers], selectedUser: newState.selectedUser || state.selectedUser }
        }
        case UPDATE_RIS_USER_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.risUser.userId);
            if (index > -1) {
                let user = { ...newUsers[index] };
                let risUsers = user.risUsers && user.risUsers.length > 0 ? [...user.risUsers] : [];
                let risUserIndex = risUsers.findIndex(risUser => risUser.risId === action.risUser.risId);
                if (risUserIndex > -1) {
                    risUsers.splice(risUserIndex, 1, { ...risUsers[risUserIndex], ...action.risUser });
                }
                user.risUsers = [...risUsers];
                newUsers.splice(index, 1, { ...user });
            }
            return { ...state, submitting: false, users: [...newUsers] }
        }
        case DELETE_RIS_USER_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.payload.userId);
            if (index > -1) {
                let user = { ...newUsers[index] };
                let risUsers = user.risUsers ? [...user.risUsers] : [];
                risUsers = risUsers.filter(risUser => risUser.risId !== action.payload.risId);
                user.risUsers = [...risUsers];
                newUsers.splice(index, 1, { ...user });
            }
            return { ...state, users: [...newUsers] }
        }
        case CREATE_RIS_USER_ERROR:
        case ADD_UPDATE_RIS_USER_MIPS_ERROR:
        case UPDATE_RIS_USER_ERROR:
        case DELETE_RIS_USER_ERROR: {
            return { ...state, submitting: false, error: action.error, message: '' };
        }
        case SET_USERS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case UNASSIGN_USER_MIP_SUCCESS: {
            newState = { ...state }
            newState.userMips = newState.userMips.filter(userMip => userMip.userMipId !== action.userMipId)
            return { ...newState }
        }
        case FETCH_USER_SKILLS_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.payload.userId);
            if (index > -1) {
                newUsers.splice(index, 1, { ...newUsers[index], userSkills: action.payload.userSkills });
                newState.selectedUser = newUsers[index];
            }
            newState.users = [...newUsers];
            return newState;
        }
        case ADD_USER_SKILL_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.userSkill.userId);
            if (index > -1) {
                let selectedUserLocal = { ...newUsers[index] };
                let updatedUserSkills = [...(selectedUserLocal.userSkills || []), action.userSkill];
                selectedUserLocal = { ...selectedUserLocal, userSkills: updatedUserSkills };
                newUsers.splice(index, 1, selectedUserLocal);
                newState.selectedUser = selectedUserLocal;
            }
            newState.users = [...newUsers];
            return newState;
        }
        case DELETE_USER_SKILL_SUCCESS: {
            newState = { ...state }
            newUsers = [...newState.users];
            index = newUsers.findIndex(user => user.userId === action.userSkill.userId);
            if (index > -1) {
                let selectedUserLocal = { ...newUsers[index] };
                let pendingUserSkills = (selectedUserLocal.userSkills || []).filter(userSkill => userSkill.skillId !== action.userSkill.skillId)
                selectedUserLocal = { ...selectedUserLocal, userSkills: pendingUserSkills };
                newUsers.splice(index, 1, selectedUserLocal);
                newState.selectedUser = selectedUserLocal;
            }
            newState.users = [...newUsers];
            return newState;
        }

        case FETCH_USER_MIPS_SUCCESS: {
            newState = { ...state }
            newState.userMips = action.userMips.length > 0 ? [...action.userMips] : [];
            return { ...newState }
        }

        case FETCH_USER_MIPS_ERROR: {
            newState = { ...state }
            newState.userMips = [];
            return { ...newState }
        }

        case ASSIGN_USER_MIP_SUCCESS: {
            newState = { ...state };
            const newMip = action.userMip;
            const index = newState.userMips.findIndex(mip => mip.mipId === newMip.mipId);
            if (index > -1) {
                newState.userMips[index] = { ...newState.userMips[index], ...newMip };
            } else {
                newState.userMips.push(newMip);
            }
            return { ...newState };
        }

        case RESET_USER_MIPS: {
            newState = { ...state };
            newState.userMips = [];
            return { ...newState }
        }

        case UPDATE_USER_MIPS_SUCCESS: {
            newState = { ...state };
            newState.userMips = [...action.userMips];
            return { ...newState }
        }

        default:
            return state;
    }
}

export default usersReducer;
